import { createContext } from 'react';
import { useThemePreferences } from './preferences/useThemePreferences';

export type ThemePreferencesState = ReturnType<typeof useThemePreferences>;

export const ThemeContext = createContext<ThemePreferencesState | null>(null);
